import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-h5 font-weight-bold" }, "Log in", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_LoginError = _resolveComponent("LoginError")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "center",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "10",
        lg: "6",
        class: "pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            color: "background",
            class: "px-4 py-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "pb-40",
                justify: "space-around"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LoginError, { error: _ctx.error }, null, 8, ["error"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_form, {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkEmail(_ctx.username)), ["prevent"])),
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            type: "email",
                            autofocus: "",
                            class: "custom-field",
                            placeholder: "Email address",
                            "persistent-placeholder": "",
                            variant: "outlined",
                            "bg-color": "#ffffff",
                            modelValue: _ctx.username,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                              _ctx.clearError
                            ],
                            rules: [v => !!v && v.length && v.includes('@') || false],
                            autocomplete: "username"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { justify: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "relative d-flex justify-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            width: "95",
                            type: "submit",
                            color: "secondary",
                            disabled: !_ctx.username || !_ctx.valid || _ctx.loading,
                            loading: _ctx.loading,
                            class: "text-none"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Confirm")
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}